// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"0da30c4868f80da13552","678":"8666cd78405b7979a19e","682":"d907b82fe3bbd1cb34d5","883":"62d4d8828b68b8b89c6f"}[chunkId] + ".js";
};